import { useState, useEffect } from "react";
import { Share, ShareResult } from "@capacitor/share";
import { Capacitor } from "@capacitor/core";

export interface ShareOptions {
  text?: string;
  title?: string;
  url?: string;
}

export function useShare(): {
  canShare: boolean;
  share: (data: ShareOptions) => Promise<ShareResult | void>;
} {
  const [canShare, setCanShareData] = useState(false);
  const isNativePlatform = Capacitor.isNativePlatform();

  useEffect(() => {
    (async () => {
      setCanShareData(isNativePlatform ? (await Share.canShare()).value : Boolean(navigator.canShare));
    })();
  }, [isNativePlatform]);

  const nativeShare = async (data: ShareOptions) => {
    try {
      await Share.share(data);
    } catch (err) {
      console.warn(err);
    }
  };

  const navigatorShare = async (data: ShareOptions) => {
    try {
      await navigator.share(data);
    } catch (error) {
      console.warn(error);
    }
  };

  return {
    canShare,
    share: isNativePlatform ? nativeShare : navigatorShare,
  };
}

export default useShare;
